import React from 'react';
import { SEARCH_PLACEHOLDER } from '../../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import type { AccreditationGridTableProps } from '../../AccreditationForm/types';
import { PlayersDropdown } from '../../AccreditationForm/components/PlayersDropdown';
import { PlayerPortalsForm } from 'libs/common-forms-ui/src/lib/PlayerPortals/PlayerPortalsForm/PlayerPortalsForm';

import styles from '../DataGridTable.module.scss';

type TableToolbarProps = {
  title: string | undefined;
  searchQuery: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accreditationGridTable?: AccreditationGridTableProps;
  onAccreditationFormClosed?: () => void;
  accreditationsFetched?: boolean;
  accreditationFormKontentItemCodename?: string;
};

export const TableToolbar = ({
  title,
  searchQuery,
  onSearchChange,
  accreditationGridTable,
  onAccreditationFormClosed,
  accreditationsFetched,
}: TableToolbarProps) => {
  const accreditationContactForm =
    accreditationGridTable?.accreditationContactForm;
  const accreditationFormProps: React.ComponentProps<
    typeof PlayerPortalsForm
  > | null = accreditationContactForm
    ? {
        ...accreditationContactForm,
        isAccreditationForm: true,
        accreditationFormOpenBtnLabel:
          accreditationGridTable?.addNewRecordCTALabel,
        customId: accreditationGridTable?.selectedPlayerId,
        onFormClosed: onAccreditationFormClosed,
        maxNumberOfNominatedForDinner:
          accreditationGridTable?.maxNumberOfNominatedForDinner,
        currentNominatedForDinnerCount:
          accreditationGridTable?.currentNominatedForDinnerCount,
        maxNumberOfApplicationsPerRole:
          accreditationGridTable?.maxNumberOfApplicationsPerRole,
        currentApplicationsPerRoleCount:
          accreditationGridTable?.currentApplicationsPerRoleCount,
        accreditationFormKontentItemCodename:
          accreditationGridTable?.accreditationFormKontentItemCodename || '',
      }
    : null;

  return (
    <div className={styles.tableToolbar}>
      <div className={styles.left}>
        <h1 className={styles.title}>{title}</h1>

        {accreditationGridTable && accreditationGridTable?.selectedPlayerId ? (
          <PlayersDropdown
            players={accreditationGridTable.players || []}
            selectedPlayerId={accreditationGridTable.selectedPlayerId || ''}
            onPlayerChange={
              accreditationGridTable.setSelectedPlayerId || (() => {})
            }
          />
        ) : null}
      </div>

      <div className={styles.right}>
        {accreditationGridTable && accreditationFormProps && (
          <PlayerPortalsForm
            {...accreditationFormProps}
            hasFetchedAccreditations={accreditationsFetched}
          />
        )}
        {!accreditationGridTable && (
          <div className={styles.searchBox}>
            <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
            <input
              type="text"
              placeholder={SEARCH_PLACEHOLDER}
              value={searchQuery}
              onChange={onSearchChange}
              className={styles.searchInput}
            />
          </div>
        )}
      </div>
    </div>
  );
};
